// extracted by mini-css-extract-plugin
export default {"image":"GifDisplay_image__h3UdT"};